/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ComuneCompactListFilter } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelComuneCompactDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListMyComuniRequestParams {
    filter: ComuneCompactListFilter;
    pageable: Pageable;
}


export interface ComuniVistaOperativaCallerScopedServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista paginata dei comuni gestiti dal caller (anagrafica). Audience: ADMIN, OP_COMUNE, OP_PRATICA, OP_PRATICA_ESERCENTE, OP_SERVIZIO.
     * 
     * @endpoint get /api/v1/gestione/comuni/me
* @param requestParameters
     */
    listMyComuni(requestParameters: ListMyComuniRequestParams, extraHttpRequestParams?: any): Observable<PagedModelComuneCompactDTO>;

}
